import { TooltipTrigger } from '@design/components/tooltip/Tooltip';
import MicrosoftLogo from '@static/images/icons/microsoft-logo.svg';
import { TooltipContainer } from '@terminal/components/tooltip-container/TooltipContainer';
import { appPaths } from '@terminal/routes/app-paths';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { usePosthogEvents } from '@terminal/services/tracking/posthog/use-posthog-events/usePosthogEvents';
import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';
import { useMatch, useNavigate } from 'react-router';
import styles from './ConnectMicrosoft.module.scss';

interface ConnectMicrosoftProps {
  isHistoryExpanded: boolean;
}

export const ConnectMicrosoft = ({
  isHistoryExpanded,
}: ConnectMicrosoftProps) => {
  const { t } = useTranslation(['chat']);
  const navigate = useNavigate();

  const { trackConnectionAppConnect } = usePosthogEvents();
  const isActive = useMatch(appPaths.alfredAppConnection);

  const handleClick = () => {
    trackConnectionAppConnect(
      POSTHOG_TRACKING_SOURCES.ALFRED_CONNECTION_APPS_PANEL
    );
    navigate(appPaths.alfredAppConnection);
  };

  return (
    <TooltipContainer
      label={t('chat:historySidebar.connectMicrosoftApps')}
      inPortal
      trigger={[TooltipTrigger.Hover]}
      disabled={isHistoryExpanded}
    >
      <div
        className={clsx(styles.buttonWrapper, {
          [styles.active]: isActive,
        })}
        onClick={handleClick}
        data-testid="connect-microsoft-button"
      >
        <div className={styles.microsoftLogoWrapper}>
          <MicrosoftLogo />
        </div>
        {isHistoryExpanded && t('chat:historySidebar.connectMicrosoftApps')}
      </div>
    </TooltipContainer>
  );
};
